import { Slider } from './Slider';
export * from './Slider';
export * from './RangeSlider';
export * from './props';
export default Slider;